import { requestPublicJson } from './api.js';

const base = (token) => `/api/expert-contributions/${encodeURIComponent(token)}`;
export const expertContributionsApi = {
  workspace: (token) => requestPublicJson(base(token), { cache: 'no-store' }),
  accept: (token, input) => requestPublicJson(`${base(token)}/accept`, { method: 'POST', body: input }),
  save: (token, input) => requestPublicJson(`${base(token)}/draft`, { method: 'PATCH', body: input }),
  submit: (token) => requestPublicJson(`${base(token)}/submit`, { method: 'POST', body: {} }),
  withdraw: (token) => requestPublicJson(`${base(token)}/withdraw`, { method: 'POST', body: {} }),
};
